import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { AppForm } from "@/shared/Components";
import type { ModalProps } from "antd/lib";
import type React from "react";
import { ModalWrapper } from "../ModalWrapper";
import { modalTableSettingSchema, type ModalTableSettingFormValues } from "./schema";
import { ModalContentLayout } from "./ModalTableSettingContent/layout";

interface Props extends ModalProps {
  onSubmit: (data: ModalTableSettingFormValues) => void;
  defaultValues: ModalTableSettingFormValues;
}

export const ModalTableSetting: React.FC<Props> = ({
  onSubmit,
  onCancel = () => "",
  defaultValues,
  ...props
}) => {
  const { t } = useTranslation();

  const formApi = useForm({
    resolver: yupResolver(modalTableSettingSchema),
    values: defaultValues,
  });

  const submitHandler = (data: ModalTableSettingFormValues) => {
    onSubmit(data);
    formApi.reset();
  };

  const cancelHandler: ModalProps["onCancel"] = (e) => {
    formApi.reset();
    onCancel(e);
  };

  return (
    <ModalWrapper
      type="save"
      modalTitle={t("contactsPage.tableSettings")}
      width={420}
      okButtonProps={{ htmlType: "submit" }}
      modalRender={(node) => (
        <AppForm onSubmit={submitHandler} formApi={formApi}>
          {node}
        </AppForm>
      )}
      onCancel={cancelHandler}
      {...props}
    >
      <ModalContentLayout />
    </ModalWrapper>
  );
};
